import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { STATUS } from '../../utils/status';
import { VendorListState } from '../interfaces/interface';
import { createAnalyseBulkVendor, createAnalyseBulkVendorByTaskIDs, createBulkVendor, createBulkVendorByTaskIDs, getDownloadTemplate, getVendorList, unallocateAnalyseBulkVendor, unallocateAnalyseBulkVendorByTaskIds, unallocateBulkVendor, unallocateBulkVendorByTaskIds } from '../slices/vendorList';

const ExtraReducers = (builder: ActionReducerMapBuilder<VendorListState>) => {
  builder
  .addCase(getVendorList.pending, (state) => {
    state.getVendorStatus = STATUS.PENDING;
    state.getVendorListMessage = ""
  })
  .addCase(getVendorList.fulfilled, (state, action) => {
    state.getVendorStatus = STATUS.SUCESS;
    state.vendor = action.payload;
    state.getVendorListMessage = action.payload?.message || "Success"
  })
  .addCase(getVendorList.rejected, (state, action:any) => {
    state.getVendorStatus = STATUS.FAILED;
    state.getVendorListMessage = action.payload?.message || "An error occurred"
  })
    .addCase(getDownloadTemplate.pending, (state) => {
    state.getDownloadTemplateStatus = STATUS.PENDING;
    state.getDownloadTemplateMessage = ""
  })
  .addCase(getDownloadTemplate.fulfilled, (state, action) => {
    state.getDownloadTemplateStatus = STATUS.SUCESS;
    state.template = action.payload;
    state.getDownloadTemplateMessage = action.payload?.message || "Success"
  })
  .addCase(getDownloadTemplate.rejected, (state, action:any) => {
    state.getDownloadTemplateStatus = STATUS.FAILED;
    state.getDownloadTemplateMessage = action.payload?.message || "An error occurred"
  })
  .addCase(createBulkVendor.pending, (state) => {
    state.createVendorStatus = STATUS.PENDING;
    state.createBulkVendorMessage = ""
  })
  .addCase(createBulkVendor.fulfilled, (state, action: PayloadAction<any>) => {
    state.vendor = action.payload; 
    state.createVendorStatus = STATUS.SUCESS;
    state.createBulkVendorMessage =action?.payload?.message || "Success"
  })
  .addCase(createBulkVendor.rejected, (state, action:any) => { 
    console.log({action: action.payload})
    state.createVendorStatus = STATUS.FAILED;
    state.createBulkVendorMessage = action.payload || "An error occurred"
  })
   .addCase(createBulkVendorByTaskIDs.pending, (state) => {
    state.createVendorStatusTaskIDs = STATUS.PENDING;
    state.createBulkVendorMessageTaskIDs = ""
  })
  .addCase(createBulkVendorByTaskIDs.fulfilled, (state, action: PayloadAction<any>) => {
    state.vendorTaskIds = action.payload; 
    state.createVendorStatusTaskIDs = STATUS.SUCESS;
    state.createBulkVendorMessageTaskIDs =action?.payload?.message || "Success"
  })
  .addCase(createBulkVendorByTaskIDs.rejected, (state, action:any) => { 
    state.createVendorStatusTaskIDs = STATUS.FAILED;
    state.createBulkVendorMessageTaskIDs = action.payload || "An error occurred"
  })
  .addCase(createAnalyseBulkVendor.pending, (state) => {
    state.createAnalyseStatus = STATUS.PENDING;
    state.createAnalyseBulkVendorMessage = ""
  })
  .addCase(createAnalyseBulkVendor.fulfilled, (state, action: PayloadAction<any>) => {
    state.analyse = action.payload; 
    state.createAnalyseStatus = STATUS.SUCESS; 
    state.createAnalyseBulkVendorMessage = action.payload?.message || "Success"
  })
  .addCase(createAnalyseBulkVendor.rejected, (state, action:any) => { 
    state.createAnalyseStatus = STATUS.FAILED;
    state.createAnalyseBulkVendorMessage = action.payload?.message || "An error occurred"
  })
  .addCase(createAnalyseBulkVendorByTaskIDs.pending, (state) => {
    state.createAnalyseStatusTaskIDs = STATUS.PENDING;
    state.createAnalyseBulkVendorMessageTaskIDs = ""
  })
  .addCase(createAnalyseBulkVendorByTaskIDs.fulfilled, (state, action: PayloadAction<any>) => {
    state.analyseTaskIDs = action.payload; 
    state.createAnalyseStatusTaskIDs = STATUS.SUCESS; 
    state.createAnalyseBulkVendorMessageTaskIDs = action.payload?.message || "Success"
  })
  .addCase(createAnalyseBulkVendorByTaskIDs.rejected, (state, action:any) => { 
    state.createAnalyseStatusTaskIDs = STATUS.FAILED;
    state.createAnalyseBulkVendorMessageTaskIDs = action.payload?.message || "An error occurred"
  })
  .addCase(unallocateBulkVendorByTaskIds.pending, (state) => {
    state.createVendorUnallocateStatusTaskIDs = STATUS.PENDING;
    state.createBulkVendorUnallocateMessageTaskIDs = ""
  })
  .addCase(unallocateBulkVendorByTaskIds.fulfilled, (state, action:any) => {
    state.vendorTaskIds = action.payload;
    state.createVendorUnallocateStatusTaskIDs = STATUS.SUCESS;
    state.createBulkVendorUnallocateMessageTaskIDs = action?.payload?.message || "Success"
  })
  .addCase(unallocateBulkVendorByTaskIds.rejected, (state, action: any) => {
    state.createVendorUnallocateStatusTaskIDs = STATUS.FAILED;
    state.createBulkVendorUnallocateMessageTaskIDs = action?.payload?.message || "An error occurred"
  })

  .addCase(unallocateBulkVendor.pending, (state) => {
    state.unallocateBulkVendorStatus = STATUS.PENDING;
    state.unallocateBulkVendorMessage = ""
  })
  .addCase(unallocateBulkVendor.fulfilled, (state, action:any) => {
    state.vendor = action.payload;
    state.unallocateBulkVendorStatus = STATUS.SUCESS;
    state.unallocateBulkVendorMessage = action?.payload?.message || "Success"
  })
  .addCase(unallocateBulkVendor.rejected, (state, action: any) => {
    state.unallocateBulkVendorStatus = STATUS.FAILED;
    state.unallocateBulkVendorMessage = action?.payload?.message || "An error occurred"
  })
  
  .addCase(unallocateAnalyseBulkVendor.pending,(state, action) => {
    state.unallocateAnalyseStatus = STATUS.PENDING
    state.unallocateAnalyseBulkVendorMessage = ""
  })
  .addCase(unallocateAnalyseBulkVendor.fulfilled,(state, action)=> {
    state.analyse = action.payload
    state.unallocateAnalyseStatus = STATUS.SUCESS
    state.unallocateAnalyseBulkVendorMessage = action.payload?.message || "Success"
  })
  .addCase(unallocateAnalyseBulkVendor.rejected, (state, action:any) => {
    state.unallocateAnalyseStatus = STATUS.FAILED
    state.unallocateAnalyseBulkVendorMessage = action.payload?.message || "An error occurred"
  })

  .addCase(unallocateAnalyseBulkVendorByTaskIds.pending,(state, action) => {
    state.createAnalyseUnallocateStatusTaskIDs = STATUS.PENDING
    state.createAnalyseBulkVendorUnallocateMessageTaskIDs = ""
  })
  .addCase(unallocateAnalyseBulkVendorByTaskIds.fulfilled,(state, action)=> {
    state.analyseTaskIDs = action.payload
    state.createAnalyseUnallocateStatusTaskIDs = STATUS.SUCESS
    state.createAnalyseBulkVendorUnallocateMessageTaskIDs = action.payload?.message || "Success"
  })
  .addCase(unallocateAnalyseBulkVendorByTaskIds.rejected, (state, action:any) => {
    state.createAnalyseUnallocateStatusTaskIDs = STATUS.FAILED
    state.createAnalyseBulkVendorUnallocateMessageTaskIDs = action.payload?.message || "An error occurred"
  })
};

export default ExtraReducers;
